export default {
  login: {
    title: 'Login',
    phoneNumber: 'Your phone number',
    number: '460 1600',
    submitPhoneNumber: 'Confirm phone number',
    submitSmsCode: 'Confirm SMS code',
    smsCode: 'SMS code',
    code: 'Code',
    retry: 'Try again',
    enterPhoneNumber: 'Please enter your mobile number and we will send you a code to continue.',
    enterCode: 'Please enter the code you were sent.',
    send: 'Send number',
    continue: 'Continue',
    usageInfo: 'To use the app, we need to link your mobile number to the app.'
        + ' You only need to do this once.',
    appDiscount: {
      discountDay: 'Tuesdays are app days.',
      message: '30% discount if ordered in the app every Tuesday!',
    },
    errors: {
      phoneNumber: {
        noInput: 'Phone number missing',
        invalidInput: 'Phone number is not long enough',
      },
      smsCode: {
        noInput: 'Enter SMS code',
        invalidInput: 'SMS code must be four characters',
      },
    },
  },
  navigation: {
    back: 'Back',
  },
  deliveryMethod: {
    delivery: 'Deliver',
    pickup: 'Pickup',
  },
  footer: {
    menu: 'Menus',
    order: 'Your order',
    settings: 'Settings',
    login: 'Login',
    distancing: 'Delivery',
  },
  wolt: {
    title: 'Wolt',
    step1title: 'Where would you like it delivered? Input address and house number',
    step2title: 'Where is the entrance? Click on the map to move the pin',
    address: 'Address and house number',
    addressHint: 'Only input the address and house number. Other information comes later.',
    comment: 'Comment',
    commentHint: 'Here you can add appartment number, floor or other information related to the delivery.',
    search: 'Search',
    confirm: 'Confirm',
    addressNotFoundTitle: 'Address not found',
    addressNotFoundMessage: 'Check if the information contains only the address and house number.',
  },
  menu: {
    title: 'Menus',
    pizzaOffers: 'Pizza offers',
    lastOrderAgain: 'Order the same as last time',
    closed: 'Closed',
    opensAt: 'Opens at',
    minutes: 'min',
    pizza: 'Pizzas',
    combo: 'Pizzas and sides',
    offer: 'Offer',
    delivery: 'Home delivery',
    catering: 'Catering',
    about: 'About Greifinn',
    login: 'Login',
    logout: 'Logout',
    is: 'Enska',
    en: 'Íslenska',
  },
  categories: {
    small: 'Small',
    medium: 'Medium',
    large: 'Large',
    addToCart: 'Add to cart',
  },
  product: {
    pizza: 'Pizza',
    base: 'Crust',
    chooseBase: 'Choose crust',
    double: 'Double amount',
    triple: 'Triple amount',
    addToOrder: 'Add to order',
    chooseOptions: 'Select',
    changeProduct: 'Change',
    updateProductInOrder: 'Change product',
    split: 'Split in half',
    notSplit: 'Do not split',
    change: 'Change',
    hideToppings: 'Hide toppings',
    toppings: 'Toppings',
    chooseToppings: 'Choose toppings',
    import: 'Same toppings as',
    importFrom: 'Choose pizza from menu',
    noToppingsSelected: 'No toppings selected',
    size: {
      title: 'Choose size',
    },
    part: {
      0: 'West (Left)',
      1: 'East (Right)',
    },
    price: 'Price:',
  },
  lastOrder: {
    lastOrderAgain: 'Order again',
  },
  order: {
    editInformation: 'Edit',
    deliveryMethod: {
      title: 'Order will be ',
      waitingTime: 'Waiting time approx. ',
      deliveryETA: 'Estimated delivery after:',
    },
    save: 'Save',
    errors: {
      dialog: {
        name: 'Recipient name missing',
        ssnFormat: {
          title: 'Enter name and ID number of recipient',
          message: 'Incorrect ID number format',
        },
        ssn: {
          empty: 'Recipient ID number missing',
          length: 'ID number must be 10 digits',
        },
        save: 'Save',
      },
    },
    isEmpty: 'You haven’t added anything to your order. Browse the menu and add to your order.',
  },
  payment: {
    tds: {
      hint: 'Click "Send" to start Strong Customer Authentication (SCA) on the payment card.',
      submit: 'Send',
      cancel: 'Cancel',
    },
    valitorPage: {
      hint: 'Click "Send" to pay on the Valitor payment page.',
      submit: 'Send',
      cancel: 'Cancel',
      footer: 'If you want to cancel or when the payment is complete, it is safe to close the payment page to return.',
    },
    phoneNumber: 'Phone number',
    validation: {
      phoneNumber: {
        required: 'Phone number is missing',
        tooShort: 'Phone number is too short',
      },
    },
    aur: {
      paymentPendingTitle: 'Awaiting payment',
      paymentPendingMessage: 'Complete the payment through the Aur app to finish your order.',
    },
    verifoneCheckout: {
      hint: 'To pay for the order, you will now be taken to the Verifone payment page. After payment is received, the order will go into processing. Click "Continue" to pay on the Verifone payment page.',
      submit: 'Continue',
      cancel: 'Cancel',
      footer: 'If you want to cancel or when the payment is complete, it is safe to close the payment page to return.',
    },
    teyaPage: {
      hint: 'Click "Send" to pay on the Teya payment page.',
      submit: 'Send',
      cancel: 'Cancel',
      footer: 'If you want to cancel, or when the payment is complete, it is safe to close the payment page to return.',
    },
    invoiceInternal: {
      description: 'Please enter payment information',
      customerSsn: 'Customer number',
      ssn: 'Kennitala of requester',
      name: 'Requested by',
      save: 'Save information',
      edit: 'Change information',
      customerNotFound: 'Customer not found',
    },
  },
  cart: {
    distancing: 'Contactless delivery',
    deliveryMethod: 'Delivery method',
    buyer: 'Buyer',
    correctInformation: 'Is all the information correct?',
    lastOrder: 'Same as last time',
    order: 'Your order',
    orderSingular: 'Order',
    changeOrder: 'Edit',
    remove: 'Delete',
    price: 'kr.',
    saveProduct: 'Save',
    removeDialogTitle: 'Delete product',
    removeDialogMessage: 'Are you sure you want to delete the product from the cart?',
    backToMenu: 'Back to menu',
    confirmOrder: 'Confirm order',
    total: 'Total: ',
    cardNumber: 'Card no.',
    secondCardNumber: 'New card number',
    month: 'Month',
    year: 'Year',
    cvv: 'CVC',
    saveCardNumber: 'Save card',
    payOnArrival: 'Pay when you pick up at Greifinn',
    paymentTitle: 'Choose payment method',
    finalizeOrder: 'Finalize order',
    minimumPrice: 'Minimum amount for home delivery is',
    sideDishes: {
      title: 'Would you like to',
      message: 'add to the order?',
      choose: 'Choose sides',
      noSelection: 'No sides selected',
      drinks: 'Drinks',
      sides: 'Sides',
      childrenDishes: 'Kids’ meals',
    },
    deliveryMethodDialog: {
      title: 'Delivery method',
      pickup: 'Pickup',
      delivery: 'Home delivery',
      waitingTime: 'Waiting time approx. ',
      methodIsClosed: 'Closed',
      deliveryNoticeSprettur: 'Home deliveries are handled by Sprettur employees',
    },
    credit: {
      useCredit: 'Use credit',
      noCredit: 'You have no credit to use',
    },
    coupon: {
      title: 'Discount code',
      valid: 'Confirmation code active!',
      activate: 'Activate',
      hint: 'Enter the discount code and then click ACTIVATE',
    },
    confirmAddress: {
      title: 'Correct address?',
      no: 'No',
      yes: 'Yes',
    },
    chooseAddress: {
      title: 'Choose address',
      new: 'Create new',
      newAddress: 'Create new address',
      cancel: 'Cancel',
      confirm: 'Select',
    },
    confirm: {
      title: 'Confirm order',
      message: 'Is everything correct?',
    },
    clear: {
      title: 'Cancel order',
      message: 'All items will be removed from the order',
      ok: 'Yes',
      cancel: 'No',
    },
    paymentMethod: {
      title: 'Pay for order',
      invoice: {
        description: 'This order will be charged to the account of customer {externalId}.',
      },
    },
  },
  distancing: {
    whatIs: 'What is contactless delivery?',
  },
  summary: {
    title: 'Thank you for your order and enjoy your meal',
    methods: 'Sent/Picked up',
    ready: 'Estimated delivery time is',
    backToMenu: 'Back to home page',
    trackWithWolt: 'Track order with Wolt',
    note: 'View receipt',
  },
  settings: {
    title: 'Settings',
    desktopTitle: 'Information',
    lastOrder: {
      title: 'Last order',
    },
    userItems: {
      title: 'My dishes',
      noItems: 'No dishes have been saved. The next time you order, you can choose to save the dish. It will then appear in this list, making it easier to order again later.',
      dialog: {
        title: 'Confirmation',
        message: 'Do you want to delete the product from my dishes?',
      },
    },
    orders: {
      title: 'My orders',
      receipt: 'View receipt',
      name: 'Greifinn',
      restaurant: 'Restaurant',
      ready: 'Ready at:',
      ordered: 'Ordered at:',
      description: 'Product description',
      price: 'Price',
      total: 'Total',
      piece: 'pcs @',
      empty: '- Nothing selected -',
      first: '** First half **',
      second: '** Second half **',
      distancing: 'Contactless delivery',
      more: 'See more',
      noMore: 'No more orders',
      paymentMethodNotFound: 'Payment method not found',
      deliveryMethodNotFound: 'Delivery method not found',
    },
    addresses: {
      title: 'Addresses',
      add: 'Add address',
      edit: 'Edit address',
      default: 'Selected address',
      setAsDefault: 'Set as default address',
      address: 'Address',
      addressError: 'Please enter an address',
      notes: 'Floor or other information',
      postalCode: 'Postal code',
      postalCodeError: 'Please select a postal code',
      save: 'Save',
      cancel: 'Cancel',
      confirmation: 'Confirmation',
      message: 'Do you really want to delete the address?',
    },
    cards: {
      title: 'Saved cards',
      addCard: 'Add card',
      removeCard: 'Delete card',
      removeCardConfirm: 'Are you sure you want to delete this card?',
      error: 'Error',
      cancel: 'Cancel',
      noRegisteredCards: 'You have no saved cards. Click the button below to add a card.',
      expiration: 'Card valid until',
      cardNumberRequired: 'Card number missing',
      cardNumberInvalid: 'Incorrect format',
      monthRequired: 'Month missing',
      monthInvalid: 'Month does not exist',
      yearRequired: 'Year missing',
      yearInvalid: 'Incorrect format',
      yearHasPassed: 'Card has expired',
      ccvRequired: 'CCV missing',
      ccvInvalid: 'Incorrect format',
    },
    logout: {
      title: 'Log me out',
      cancelOrder: 'Cancel order',
      message: 'Are you sure you want to log out?',
    },
    userInformation: {
      title: 'My information',
      phone: 'Phone number',
      name: 'Full name',
      ssn: 'ID number for invoice',
      ssnMessage: 'Only if ID number needs to appear on the invoice',
      extra: 'Extra information',
      save: 'Save',
      customer: 'Customer',
    },
    products: {
      title: 'My dishes',
      dialog: {
        title: 'Choose a name for the dish',
        send: 'Save',
        error: 'Name missing',
      },
    },
  },
  notifications: {
    defaultTitle: 'Message',
    addedToOrder: '{thing} added to order',
    updatedInOrder: '{thing} updated in order',
  },
  dialog: {
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    save: 'Save',
    confirm: 'Confirm',
    submit: 'Send',
    forward: 'Continue',
    change: 'Change',
  },
  form: {
    error: {
      required: 'This field is required',
      invalidSsn: 'Invalid kennitala',
      invalidPersonSsn: 'Kennitala can not be a buisness kennitala',
      sameAsCustomerSsn: 'Kennitala can not be the same as the customer number',
    },
  },
  api: {
    error: {
      pilotErrorWoltServiceError: {
        title: 'Error communicating with Wolt',
        message: 'Wolt service has returned an error.',
      },
      pilotErrorInvalidPhoneNumber: {
        title: 'Invalid phone number',
        message: 'The system only accepts icelandic mobile phone numbers.',
      },
      pilotErrorDeliveryDataMissing: {
        title: 'Order not saved',
        message: 'Missing information about delivery.',
      },
      pilotErrorPaymentGatewayError: {
        title: 'Error communicating with payment service',
        message: 'Message from payment service: {error}',
      },
      pilotErrorInvalidVerificationCode: {
        title: 'Incorrect verification code',
        message: 'Check if it is entered correctly.',
      },
      pilotErrorCouponExpired: {
        title: 'Discount code expired',
        message: 'The code you provided is not active.',
      },
      pilotErrorCouponNotFound: {
        title: 'Discount code not found',
        message: 'Check if it is entered correctly.',
      },
      pilotErrorInvalidCardNumber: {
        title: 'Invalid card number',
        message: 'Check if you have provided the correct number.',
      },
      pilotErrorExpiredCard: {
        title: 'Card expiration date has passed',
        message: 'Try another card or another payment method.',
      },
      pilotErrorInvalidCardLength: {
        title: 'Error in card number',
        message: 'Card number must be 11 to 19 digits',
      },
      pilotErrorOrderNotSaved: {
        title: 'Communication error',
        message: 'Could not save order. Possible reasons could be problems with internet connection.',
      },
      pilotErrorOrderNotValid: {
        title: 'No order found',
        message: 'This can happen if the product selection changes.',
      },
      pilotErrorItemNotAllowedForDeliveryMethod: {
        title: 'We cannot process "{product}"',
        message: 'You must choose another delivery method.',
      },
      pilotErrorDeliveryMethodMinTotalPrice: {
        title: 'Minimum amount not reached',
        message: 'To choose this delivery method, you must order more.',
      },
      pilotErrorCouponWrongDeliveryMethod: {
        title: 'Discount code not allowed',
        message: 'This discount code is not available for this delivery option.',
      },
      pilotErrorPaymentDataShouldNotBeSupplied: {
        title: 'Error - Order not received',
        message: 'The app needs an update. To be able to order and pay, you must update the app through the App Store or Google Play. You can also order on our website at greifinn.is. Sorry for the inconvenience.',
      },
      couponNeedsDesktop: {
        title: 'Discount code not allowed',
        message: 'This discount code is only allowed on the web.',
      },
      couponNeedsCordova: {
        title: 'Discount code not allowed',
        message: 'This discount code is only allowed in the app.',
      },
      notAllowed: {
        title: 'Action not performed',
        message: 'User does not have the required permissions.',
      },
      ECONNABORTED: {
        title: 'Communication timed out',
        message: 'Execution took an abnormally long time.',
      },
      bootFailed: {
        title: 'Error communicating with web service',
        message: 'Could not fetch necessary information from web service: {error}',
      },
      outDated: {
        title: 'App needs an update',
        message: 'To ensure everything works correctly, we recommend updating the app through the App Store or Google Play. You can also order on our website at greifinn.is.',
      },
    },
  },
  serviceWorker: {
    event: {
      updated: {
        title: 'A new version of the site is available',
        message: 'You just need to reload the page to update.',
        ok: 'Reload page',
        cancel: 'Not now',
      },
    },
  },
  date: {
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  },
};
